// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2Saxy","container":"styles_container__1x6OO","title":"styles_title__2nqPv","wrapper":"styles_wrapper__3LuvL","answer":"styles_answer__2RqFd"};